import { render, staticRenderFns } from "./BdThread.vue?vue&type=template&id=5c70b738&"
import script from "./BdThread.vue?vue&type=script&lang=js&"
export * from "./BdThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports